<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2" color="error">mdi-alert</v-icon>
        Errors log
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="(error, i) in errors" :key="i">
            <v-list-item-content>
              {{ error.message }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      errors: []
    };
  },
  methods: {
    open(errors) {
      this.errors = errors;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
